import { FC, useState } from "react";
import { FaCheck, FaFacebook } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { MdContentCopy } from "react-icons/md";
import FrameButton from "./buttons/FrameButton";
import FrameModalBody from "./modals/modalComponents/FrameModalBody";
import FrameOneModal from "./modals/modalComponents/FrameOneModal";
import { isGoNative } from "@/utils/isGoNative";
import { FacebookShareButton } from "@ciaran0/react-share";
import useOverwolfInterop from "@/hooks/useOverwolfInterop";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

interface props {
    quote: string;
    link: string;
    hashtag: string;
    isVisible: boolean;
    onClose: () => void;
}
export const FacebookShareModal: FC<props> = ({ hashtag, isVisible, link, onClose, quote }) => {
    const [isTextCopied, setIsTextCopied] = useState(false);
    const { copyToClipboard} = useCopyToClipboard();
    const handleCopyQuote = () => {
        if (isTextCopied) return;
        setIsTextCopied(true);
        copyToClipboard(quote);
        setTimeout(() => {
            setIsTextCopied(false);
        }, 10000);
    };
    return (
        <FrameOneModal size="xs1" isOpen={isVisible} toggle={onClose} contentClassName="facebook-share-modal">
            <IoMdClose className="facebook-share-modal_close" onClick={onClose} />
            <FrameModalBody className="facebook-share-modal_body">
                <div className="facebook-share-modal_body_heading">
                    <FaFacebook />
                    <div className="facebook-share-modal_body_heading_text">
                        <h5>Share to facebook</h5>
                        <span>Copy this message and paste it when you share</span>
                    </div>
                </div>
                <div className="facebook-share-modal_body_content">
                    <div className="facebook-share-modal_body_content_field">
                        <textarea value={quote} readOnly></textarea>
                        <FrameButton
                            color={isTextCopied ? "gray" : "purple"}
                            onClick={handleCopyQuote}
                            rightIcon={isTextCopied ? FaCheck : MdContentCopy}
                            size="narrow"
                        >
                            {isTextCopied ? "Copied" : "Copy"}
                        </FrameButton>
                    </div>

                    <FacebookShareButton
                        quote={quote}
                        url={link}
                        hashtag={hashtag}
                        style={{
                            backgroundColor: "transparent",
                        }}
                    >
                        <div className="facebook-share-modal_body_content_button">
                            <FaFacebook /> <span>Share to Facebook</span>
                        </div>
                    </FacebookShareButton>
                </div>
            </FrameModalBody>
        </FrameOneModal>
    );
};
